import React from "react";
import {
  Box,
  makeStyles,
  Tooltip,
  IconButton,
  Badge,
} from "@material-ui/core";
import StandardBadge from "../StandardBadge";
import {
  Android,
  Person,
  EmojiObjects,
  SwapHoriz
} from "@material-ui/icons";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  modeChip: {
    // Styles agora são controlados pelo StandardBadge
  },
  statusIndicator: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    marginLeft: theme.spacing(0.5),
  },
  activeStatus: {
    backgroundColor: theme.palette.success.main,
  },
  inactiveStatus: {
    backgroundColor: theme.palette.error.main,
  },
  takeoverButton: {
    padding: theme.spacing(0.5),
    "& .MuiSvgIcon-root": {
      fontSize: "1rem",
    },
  },
}));

const AgentModeIndicator = ({
  mode = "PROMPT",
  isActive = false,
  canTakeover = false,
  onTakeover,
  hasWarning = false,
  className,
  ...props
}) => {
  const classes = useStyles();

  const getModeConfig = () => {
    switch (mode) {
      case "AGENT_DIRECT":
        return {
          label: i18n.t("agentMode.agentDirect"),
          icon: <Android />,
          color: "success",
          tooltip: i18n.t("agentMode.agentDirectTooltip"),
        };
      case "AGENT_ASSISTANT":
        return {
          label: i18n.t("agentMode.agentAssistant"),
          icon: <EmojiObjects />,
          color: "warning",
          tooltip: i18n.t("agentMode.agentAssistantTooltip"),
        };
      case "PROMPT":
      default:
        return {
          label: i18n.t("agentMode.prompt"),
          icon: <Person />,
          color: "info",
          tooltip: i18n.t("agentMode.promptTooltip"),
        };
    }
  };

  const modeConfig = getModeConfig();

  return (
    <Box className={`${classes.root} ${className}`} {...props}>
      <Tooltip title={modeConfig.tooltip} placement="top">
        <Badge
          variant="dot"
          color={hasWarning ? "error" : "default"}
          invisible={!hasWarning}
        >
          <StandardBadge
            icon={modeConfig.icon}
            label={modeConfig.label}
            color={modeConfig.color}
            variant="filled"
            className={classes.modeChip}
          />
        </Badge>
      </Tooltip>

      <Box
        className={`${classes.statusIndicator} ${
          isActive ? classes.activeStatus : classes.inactiveStatus
        }`}
        title={
          isActive
            ? i18n.t("agentMode.activeStatus")
            : i18n.t("agentMode.inactiveStatus")
        }
      />

      {canTakeover && (
        <Tooltip title={i18n.t("agentMode.takeoverTooltip")} placement="top">
          <IconButton
            size="small"
            onClick={onTakeover}
            className={classes.takeoverButton}
            color="primary"
          >
            <SwapHoriz />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default AgentModeIndicator;